<template>
	<app-modal :sleep="sleepModal" name="book-instance" :maxWidth="800" @beforeOpen="beforeOpen">

		<template v-slot:title>
			{{EDIT_MODE ? 'Редактировать параметры книги' : 'Добавить книгу'}}
			<p class="small" v-if="shelf && !EDIT_MODE">на полку <span class="text-primary">{{shelf.name}}</span></p>
		</template>

		<template v-slot="{params}">

			<form action="#" method="post" @submit.prevent="submit({
				onSuccess: params.onSuccess
			})">
				<div class="row">
					<div class="col-12 col-sm-6">
						<div class="mb-4">
							<label for="book-name">Название книги</label>
							<input id="book-name" type="text" v-model="form.name" class="form-control" data-autofocus required>
						</div>

						<div class="mb-4">
							<label for="book-author">Автор</label>
							<input id="book-author" type="text" v-model="form.author" class="form-control">
						</div>

						<div class="mb-4">
							<label for="book-publish-house">Издательство</label>
							<input id="book-publish-house" type="text" v-model="form.publish_house" class="form-control">
						</div>

						<div class="mb-4">
							<label for="book-illustrator">Иллюстратор</label>
							<input id="book-illustrator" type="text" v-model="form.illustrator" class="form-control">
						</div>

						<div class="mb-4">
							<label for="book-image">Обложка</label>
							<input id="book-image" type="file" @change="selectCover" class="form-control">
						</div>
					</div>
					<div class="col-12 col-sm-6">
						<div class="mb-4">

							<div class="d-flex align-items-center justify-content-between">
								<label style="margin-bottom: 2px;">Дополнительные параметры</label>
								<button type="button" class="btn btn-sm btn-outline-dark text-decoration-underline py-1 mt-n1" @click="extraFields.push({name: '', val: ''})" style="border-color: rgba(0,0,0,0.15);">Добавить поле</button>
							</div>

							<div class="row gx-1 px-1 my-2">
								<div class="col-5">
									<small class="text-muted">Наименование</small>
								</div>
								<div class="col-7">
									<small class="text-muted">Значение</small>
								</div>
							</div>

							<div v-for="(field, key) in extraFieldsList" :key="'custom-field'+key">
								<div class="row align-items-center py-2 px-1 gx-2" :class="{
									'bg-light': !(key % 2)
								}">
									<div class="col-4">
										<input type="text" v-model="field.name" class="form-control form-control-sm">
									</div>
									<div class="col">
										<input type="text" v-model="field.val" class="form-control form-control-sm">
									</div>
									<div class="col-auto">
										<button type="button" class="btn btn-sm text-danger px-1" @click="removeField(field)">
											<svg width="16" height="16" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
												<g fill="currentColor">
													<path d="M27,6h-6V5c0-1.654-1.346-3-3-3h-4c-1.654,0-3,1.346-3,3v1H5C3.897,6,3,6.897,3,8v1c0,0.552,0.448,1,1,1h24  c0.552,0,1-0.448,1-1V8C29,6.897,28.103,6,27,6z M13,5c0-0.551,0.449-1,1-1h4c0.551,0,1,0.449,1,1v1h-6V5z"/>
													<path d="M6,12v15c0,1.654,1.346,3,3,3h14c1.654,0,3-1.346,3-3V12H6z M19.707,22.293  c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0L16,21.414l-2.293,2.293c-0.391,0.391-1.023,0.391-1.414,0  s-0.391-1.023,0-1.414L14.586,20l-2.293-2.293c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0L16,18.586l2.293-2.293  c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414L17.414,20L19.707,22.293z"/>
												</g>
											</svg>
										</button>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div>
					<button type="submit" class="btn btn-primary">{{EDIT_MODE ? 'Сохранить' : 'Добавить'}}</button>
				</div>
			</form>

		</template>

	</app-modal>
</template>
<script>
export default {
	data() {
		return {
			ID_BOOK: 0,
			EDIT_MODE: false,

			shelf: null,
			sleepModal: false,

			form: {
				name: '',
				author: '',
				publish_house: '',
				illustrator: '',
				image: '',
			},

			extraFields: [{name: '', val: ''}]
		}
	},
	computed: {
		extraFieldsList() {
			return this.extraFields.filter(field => !field.deleted);
		}
	},
	methods: {
		beforeOpen(e) {
			const data = e.ref.params.value;

			this.ID_BOOK   = Math.max(parseInt(data.idBook) || 0, 0);
			this.shelf     = data.shelf || null;
			this.EDIT_MODE = !!this.ID_BOOK;

			if (this.EDIT_MODE) {
				this.sleepModal = true;
				this.getBookData().then(response => {
					const book = response.data.data || null

					this.form = book ? _.objectPick(book, Object.keys(this.form)) : this.form;
					this.extraFields = book.custom;

					this.sleepModal = false;
				}).catch(() => this.sleepModal = false);
			}
		},
		getBookData() {
			return this.userapi.get(`racks/${this.shelf.id}/${this.ID_BOOK}`);
		},
		selectCover(e) {
			this.form.image = e.target.files.length ? e.target.files[0] : null;
		},

		removeField(field) {
			field.name = '';
			field.val = '';
			field.deleted = true;
		},

		submit(params) {
			const eventSuccess = params.onSuccess || function() {};

			if (!this.shelf || this.sleepModal) {
				return;
			}

			this.sleepModal = true;

			const isEdit = this.EDIT_MODE;
			const request = new FormData;
			const requestUrl = `racks/${this.shelf.id}/${isEdit ? `edit/${this.ID_BOOK}` : 'add'}`;

			// fill request data
			Object.entries(this.form).forEach(([key, value]) => {
				request.append(key, value);
			});

			// add extra fields to request
			this.extraFields.forEach((field, index) => {
				const name = field.name.trim();

				if (field.id) {
					request.append(`custom[id][${index}]`, field.id);
				}

				request.append(`custom[name][${index}]`, name);
				request.append(`custom[value][${index}]`, field.val.trim());
			});

			this.userapi.post(requestUrl, request, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(response => {

				if (!response.hasValidateErrors) {
					eventSuccess(isEdit ? 'edit' : 'add', response.data.data);
					this.$vfm.hide('book-instance');
				}

				this.sleepModal = false;
			}).catch(() => {
				this.sleepModal = false;
			});
		}
	}
}
</script>